import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { cockpitLogin } from "../../services/api";

export default function CockpitLogin() {
  const navigate = useNavigate();
  const location = useLocation();
  const inactivityMessage = location.state?.message || null;

  const [email, setEmail] = useState("admin@zoompay.co.ke");
  const [password, setPassword] = useState("Admin2026!");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const data = await cockpitLogin({ email, password });

      if (!data?.ok) {
        throw new Error(data?.error || "Login failed");
      }

      const token =
        data?.token ||
        data?.adminToken ||
        data?.data?.token ||
        data?.data?.adminToken ||
        data?.result?.token;

      if (!token) {
        throw new Error("Login succeeded but no token returned from API");
      }

      localStorage.setItem("adminToken", token);

      // Store admin info including role for display
      const adminInfo = {
        email: data?.email || email,
        role: data?.role || data?.data?.role || "admin",
        name: data?.name || data?.data?.name || email.split("@")[0],
      };
      localStorage.setItem("adminUser", JSON.stringify(adminInfo));

      navigate("/cockpit/dashboard", { replace: true });
    } catch (err) {
      console.error("Cockpit login error:", err);
      setError(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "2rem", maxWidth: "420px", margin: "0 auto" }}>
      <h1>ZoomPay Cockpit Login</h1>
      {inactivityMessage && (
        <div style={{ background: "#fef3c7", border: "1px solid #f59e0b", borderRadius: "6px", padding: "10px 14px", marginTop: "12px", color: "#92400e", fontSize: "14px" }}>
          ⏱️ {inactivityMessage}
        </div>
      )}

      <form onSubmit={handleSubmit} style={{ marginTop: "1.5rem" }}>
        <div style={{ marginBottom: "1rem" }}>
          <label>Email</label>
          <input
            style={{ width: "100%", padding: "0.7rem", marginTop: "0.3rem" }}
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div style={{ marginBottom: "1rem" }}>
          <label>Password</label>
          <input
            style={{ width: "100%", padding: "0.7rem", marginTop: "0.3rem" }}
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        {error && (
          <div style={{ color: "red", marginBottom: "1rem" }}>
            ❌ {error}
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          style={{
            width: "100%",
            padding: "0.8rem",
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          {loading ? "Logging in..." : "Login"}
        </button>
      </form>
    </div>
  );
}
